import { ModelScreenerFieldType } from "@models/model-screener/enums/fieldType";
import { ModelScreenerFilterType } from "@models/model-screener/enums/filterType";
import { SHFilterOption } from "@components/design-systems";
import {
  ModelScreenerColumnSettingDTO,
  ModelScreenerFilterDTO,
} from "@models/model-screener/entities/modelScreenerFilter";

export type ModelScreenerData = {
  headers: ModelScreenerMainHeader[];
  data: ModelScreenerRow[];
  filter?: ModelScreenerFilterDTO;
  columnSetting?: ModelScreenerColumnSettingDTO;
};

// Interfaces
export interface ModelScreenerMainHeader {
  id: string;
  name: string;
  order: number;
  subHeaders: ModelScreenerSubHeader[];
}

export interface ModelScreenerSubHeader {
  id: string;
  name: string;
  fullName?: string | null;
  description?: string | null;
  fieldTypeId: ModelScreenerFieldType;
  sortable: boolean;
  filterType: ModelScreenerFilterType | null;
  filterData?: SHFilterOption[] | null;
  order: number;
  hiddenByDefault: boolean;
  size: number;
}

export interface ModelScreenerRow {
  id: string;
  isFavourited?: boolean;
  data: ModelScreenerCellData[];
}

export interface ModelScreenerCellData {
  mainHeaderId: string;
  subHeaderId: string;
  value: string;
  originalValue?: string | null;
  additionalValue?: string | null;
  tooltip: ModelScreenerTooltip | null;
  isRestricted?: boolean;
  shouldShowCaution?: boolean;
}

export interface ModelScreenerTooltip {
  header?: string | null;
  additionalText?: string | null;
}

export class ModelScreenerExportModelsDto {
  adviserName?: string = "";
  practiceName?: string = "";
  managerDownload?: boolean = true;
  seriesDownload?: boolean = true;
  modelDownload?: boolean = true;
  exportExcel?: boolean = true;
  exportWord?: boolean = false;
  performanceStartDate?: Date | null = null;
  performanceEndDate?: Date | null = null;
  rows: ModelScreenerRow[] = [];
  headers: ModelScreenerMainHeader[] = [];
  columnSetting?: ModelScreenerColumnSettingDTO | null = null;
}

export type MSExcelDownloadDto = {
  adviserName: string;
  practiceName: string;
  downloaderName: string;
  downloaderFirmName: string;
  sheets: MSExcelDownloadSheetData[];
};

export type MSExcelDownloadSheetData = {
  id: string;
  name: string;
  title: string;
  sections: MSExcelDownloadSection[];
};

export type MSExcelDownloadSection = {
  name: string;
  isDescriptionSection?: boolean;
  rowData?: MSExcelRowData | null;
  subSections?: MSExcelDownloadSubSection[] | null;
  features?: MSExcelDownloadFeature[] | null;
};

export type MSExcelDownloadSubSection = {
  name: string;
  rowData?: MSExcelRowData | null;
  features?: MSExcelDownloadFeature[] | null;
};

export type MSExcelDownloadFeature = {
  name: string;
  rowData: MSExcelRowData;
};

export type MSExcelRowData = {
  fieldType: string;
  cellData: MSExcelDownloadCellData[];
};

export type MSExcelDownloadCellData = {
  value: string;
  additionalValue?: string | null;
};
